import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const DesignationApi = createApi({
  reducerPath: "DesignationApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Designationt API's-------------------------------------------
    getAllDesignationData: builder.query({
      query: () => "get_all_designations",
      transformResponse: (response) => response?.data || [],
    }),

    getDesignationById: builder.query({
      query: (id) => `get_single_designation/${id}`,
      transformResponse: (response) => response?.data || [],
    }),

    addDesignation: builder.mutation({
      query: (addDesi) => ({
        url: "add_designation",
        method: "POST",
        body: addDesi,
      }),
    }),

    editDesignation: builder.mutation({
      query: (editDesi) => ({
        url: `update_designation`,
        method: "PUT",
        body: editDesi,
      }),
    }),

    deleteDesignation: builder.mutation({
      query: (id) => ({
        url: `delete_designation/${id}`,
        method: "DELETE",
      }),
    }),

    getDeptBySubDeptId: builder.query({
      query: (id) => `get_subdept_from_dept/${id}`,
      transformResponse: (response) => response?.data,
    }),

    getSubDeptByDesiId: builder.query({
      query: (id) => `get_all_designation/${id}`,
      transformResponse: (response) => response?.data,
    }),
    getDesiDeptAuth: builder.query({
      query: (id) => `get_single_desi_dept_auth/${id}`,
      transformResponse: (response) => response?.data,
    }),

    editDeptDesiAuth: builder.mutation({
      query: (editDesi) => ({
        url: `update_dept_desi_auth`,
        method: "PUT",
        body: editDesi,
      }),
    }),

    //END Designationt API's-------------------------------------------
  }),
});

export const {
  //designation api
  useGetAllDesignationDataQuery,
  useGetDesignationByIdQuery,
  useAddDesignationMutation,
  useEditDesignationMutation,
  useDeleteDesignationMutation,

  useGetDeptBySubDeptIdQuery,
  useGetSubDeptByDesiIdQuery,
  useGetDesiDeptAuthQuery,
  useEditDeptDesiAuthMutation,
} = DesignationApi;

export default DesignationApi;
